import { createSlice } from '@reduxjs/toolkit'
import { createSetter } from 'shared/redux-helpers'

const initialState = {
	finishStep: '',
	name: '',
	zoomMessageWindow: ''
}

type Slice = typeof initialState

const campaignCreateSlice = createSlice({
	initialState,
	name: 'campaignCreate',
	reducers: {
		// setName: createSetter("name"), ! unused old CAMPAIGN_CREATE
		setFinishStep: createSetter<Slice>('finishStep'),
		setZoom: createSetter<Slice>('zoomMessageWindow')
	}
})

const campaignCreateActions = campaignCreateSlice.actions

export { campaignCreateActions, campaignCreateSlice }
